<template>
	<v-layout row>
		<v-btn :disabled="disabled" @click="datepicker = true"
			>{{ label }} : {{ model | formatDateTime }}
			<v-icon @click.stop="remove" v-if="stringDate">close</v-icon>
		</v-btn>

		<v-time-picker
			:hint="hint"
			persistent-hint
			v-on-clickaway="closeTimePicker"
			:allowed-minutes="(val) => [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55].includes(val)"
			v-model="stringTime"
			v-if="timepicker"
			dark
			v-on:change="setDate"
			class="fixed-error"
		></v-time-picker>
		<v-date-picker
			first-day-of-week="1"
			v-on-clickaway="closeDatePicker"
			no-title
			v-model="stringDate"
			v-if="datepicker"
			dark
			v-on:change="choseDate()"
			color="secondary"
			class="fixed-error"
		></v-date-picker>

		<!-- handling error and validator -->
		<v-text-field v-model="model" class="custom-error" :rules="computedRules"></v-text-field>
	</v-layout>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'
import BaseInput from './baseInput'
export default {
	extends: BaseInput,
	mixins: [clickaway],
	data() {
		return {
			stringTime: null,
			stringDate: null,
			datepicker: false,
			timepicker: false,
		}
	},
	methods: {
		remove() {
			this.stringTime = null
			this.stringDate = null
			this.model = null
			this.timepicker = false
			this.datepicker = false
			this.update()
		},
		closeDatePicker() {
			this.datepicker = false
		},
		closeTimePicker() {
			this.timepicker = false
		},
		choseDate() {
			this.datepicker = false
			this.timepicker = true
		},
		setDate() {
			let date = new Date(this.stringDate)
			date.setHours(this.stringTime.split(':')[0])
			date.setMinutes(this.stringTime.split(':')[1])
			this.model = date
			this.datepicker = false
			this.timepicker = false
			this.update()
		},
	},
}
</script>
<style lang="scss">
.bo-input .v-picker.fixed-error {
	position: absolute !important;
}
</style>



// WEBPACK FOOTER //
// src/baseComponents/inputs/dateTimeInput.vue